export function App(): JSX.Element {
  return (
    <main>
      <h1>DineRate · Diner</h1>
      <p>Scan a table QR to leave a rating. Implementation lands in Phase 2.</p>
      <footer><small>Maintained by Blake and team, with Kevin and Ben</small></footer>
    </main>
  );
}
